import styled, { css } from "styled-components";

const Wrapper = styled.li`
  // Avoid issues with WordPress own styling.
  margin-bottom: 0;
  
  ${props =>
    0 === props.childItems.length &&
    css`
      margin-left: 10px;
    `};
`;

export default Wrapper;
